import { useMemo } from "react";
import { marked } from "marked";
import LegalPage from "./LegalPage";

const markdown = `# Unofficial Application

*Important information about this application*

## Official Disclaimer

***SEND IT*** is an unofficial, fan-made motorsport prediction game. This application is not affiliated with, endorsed by, sponsored by, or in any way officially connected to Formula One World Championship Limited, the Fédération Internationale de l'Automobile (FIA), Formula One Management, or any Formula 1 team or driver.

## Trademark Notice

The following names and marks are registered trademarks of their respective owners:

- F1®, FORMULA 1®, FORMULA ONE® — Formula One Licensing B.V.
- FIA®, FIA FORMULA ONE WORLD CHAMPIONSHIP® — Fédération Internationale de l'Automobile
- GRAND PRIX® and related marks — Formula One Licensing B.V.
- All team names, driver names, and associated logos are trademarks of their respective owners

## Purpose of This Application

***SEND IT*** is created purely for entertainment and fan engagement purposes. We aim to provide a fun prediction game for motorsport enthusiasts, create a community for fans to engage with the sport through head-to-head driver matchup predictions, and celebrate the excitement of Formula 1 racing.

## Fair Use of Public Information

This application uses publicly available information about motorsport events, including race schedules and calendar information, driver names and nationalities, and race results from official sources. We use generic terminology and do not use official logos, fonts, or branding elements. Any resemblance to official F1 branding is unintentional.

## No Commercial Affiliation

***SEND IT*** is a free-to-play service with no commercial relationship with any motorsport organisation. We do not sell official merchandise or licensed products, claim any official partnership or sponsorship, use official broadcast footage or imagery, or represent ourselves as an official F1 product or service.

## No Gambling

***SEND IT*** is a free prediction game for entertainment purposes only. No real money can be wagered, won, or lost through use of this application. Points and league rankings hold no monetary value. This is not a gambling or betting service.

## Data Sources

Race results and calendar information are sourced from publicly available data. While we strive for accuracy, we cannot guarantee the completeness or timeliness of this information. For official results and information, please visit the official Formula 1 website at [formula1.com](https://www.formula1.com).

## Contact for Concerns

If you are a rights holder and have concerns about any content on this application, please contact us at hello@sendit-app.com and we will promptly address your concerns.

---

By using ***SEND IT***, you acknowledge that this is an unofficial fan application and that you understand the distinctions outlined above.`;

export default function Disclaimer() {
  const html = useMemo(() => marked.parse(markdown) as string, []);
  return <LegalPage title="Disclaimer" content={html} />;
}
